export default __webpack_public_path__ + "assets/models/830cb19f155c18c78ca4cd32190aff56.glb";